import { AngularReactBrowserModule } from '@angular-react/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './tv-app-routing.module';
import { RouteReuseStrategy } from '@angular/router';
import { AppRouteReuseStrategy } from './data/classes/AppRouteReuseStrategy';
import { AppComponent } from './tv-app.component';
import { AppCommonModule } from './common/common.module';
import { AuthInterceptor } from './misc/interceptors/auth-interceptor';
import { RouteModule } from './application/route/route.module';
import { MiscAdapter } from 'src/adapters/misc-adapter';
import { PromotionService } from './services/promotion.service';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        AngularReactBrowserModule,
        HttpClientModule,
        RouteModule,
        AppRoutingModule,
        AppCommonModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: RouteReuseStrategy,
            useClass: AppRouteReuseStrategy
        },
        CookieService,
        MiscAdapter,
        PromotionService,
    ],
    bootstrap: [AppComponent],
    entryComponents: []
})
export class AppModule {
}
